







































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import HeaderApi from '@/api/shopMall/pcMallDecorate/headerSet/index.ts'
import SelectUrl from '../floorSet/components/selectUrl.vue'
@Component({
  components: {
    SelectUrl
  }
})
export default class Swiper extends Vue {
  color1 = '#000000'
  color2 = '#FF9999'
  defaultUrl: string = ''

  mounted() {
    HeaderApi.getConfig('NavigationBarBackgroundConfig')
      .then((res) => {
        console.log(res)
        if(res.data.navColor) {
          this.color1 = res.data.navColor?res.data.navColor:'#000000'
          this.color2 = res.data.navborderColor?res.data.navborderColor: '#FF9999'
        }else {
          this.color1 = '#000000'
          this.color2 = '#FF9999'
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  handleChangeColor(e) {
    console.log(e)
    this.color1 = e
  }
  handleChangeBorderColor(e) {
    this.color2 = e
  }
  /**
   * 提交
   */
  handleSubmit() {
    HeaderApi.updateConfig('NavigationBarBackgroundConfig', '导航底色设置', {
      navColor: this.color1,
      navborderColor: this.color2,
    })
      .then((res) => {
        console.log(res)
        this.$Notice.success({
          desc: '修改成功',
        })
        this.$router.push({
          name: 'pcMallDecorate',
        })
      })
      .catch((err) => {
        console.log(err)
        this.$Notice.warning({
          title: '修改失败',
        })
      })
  }
}
